// Story 1.20 — GDPR rights page at /account/gdpr.
//
// Composes the four DSAR surfaces in one place:
//   * DataExportSection (Article 15)
//   * PortabilityExportSection (Article 20)
//   * Erasure surface — link to /account/danger-zone/delete (reuses
//     Story 1.19's DangerZonePage)
//   * RectificationForm (Article 16 admin-mediated)
//
// Deep-link-only at v1 (same rationale as Story 1.19's DangerZonePage —
// surfaces in Account Settings tab navigation when that lands).

import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@greenhold/components";
import { Link } from "react-router-dom";

import { DataExportSection } from "../features/gdpr/DataExportSection";
import { PortabilityExportSection } from "../features/gdpr/PortabilityExportSection";
import { RectificationForm } from "../features/gdpr/RectificationForm";

export function GdprPage() {
  return (
    <main className="min-h-screen bg-brand-paper-200 p-8">
      <div className="max-w-3xl mx-auto space-y-6">
        <header>
          <h1 className="text-3xl font-heading font-bold mb-2">
            Your GDPR rights
          </h1>
          <p className="text-base opacity-80">
            Under EU GDPR you have the right to access, rectify, export,
            and delete the data Greenhold holds about you. Each of the
            four surfaces below is documented in our handling runbook;
            response SLA is 30 days.
          </p>
        </header>

        <DataExportSection />

        <PortabilityExportSection />

        <Card>
          <CardHeader>
            <CardTitle>Delete my account (Article 17)</CardTitle>
            <CardDescription>
              Permanently erase your profile, sessions, and contact data.
              Financial audit-trail records are retained for 5 years per
              EU regulatory requirements (PSD2 + AML); your personally
              identifying data is anonymized.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="destructive" asChild>
              <Link to="/account/danger-zone/delete">
                Open account deletion flow
              </Link>
            </Button>
          </CardContent>
        </Card>

        <RectificationForm />
      </div>
    </main>
  );
}
